import { render, staticRenderFns } from "./additionalPointResume.vue?vue&type=template&id=afb16e96&"
import script from "./additionalPointResume.vue?vue&type=script&lang=js&"
export * from "./additionalPointResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports